import { toast } from 'react-toastify';

/**
 * Toast notification utility functions
 * Provides easy-to-use methods for showing toast notifications throughout the app
 */

/**
 * Show a success toast notification
 * @param {string} message - The message to display
 * @param {object} options - Additional toast options (duration, position, etc.)
 */
export const showSuccess = (message, options = {}) => {
  toast.success(message, {
    position: options.position || 'top-right',
    autoClose: options.autoClose || 4000,
    hideProgressBar: options.hideProgressBar || false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    ...options
  });
};

/**
 * Show an error toast notification
 * @param {string} message - The message to display
 * @param {object} options - Additional toast options (duration, position, etc.)
 */
export const showError = (message, options = {}) => {
  toast.error(message, {
    position: options.position || 'top-right',
    autoClose: options.autoClose || 5000,
    hideProgressBar: options.hideProgressBar || false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    ...options
  });
};

/**
 * Show a warning toast notification
 * @param {string} message - The message to display
 * @param {object} options - Additional toast options (duration, position, etc.)
 */
export const showWarning = (message, options = {}) => {
  toast.warning(message, {
    position: options.position || 'top-right',
    autoClose: options.autoClose || 4000,
    hideProgressBar: options.hideProgressBar || false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    ...options
  });
};

/**
 * Show an info toast notification
 * @param {string} message - The message to display
 * @param {object} options - Additional toast options (duration, position, etc.)
 */
export const showInfo = (message, options = {}) => {
  toast.info(message, {
    position: options.position || 'top-right',
    autoClose: options.autoClose || 4000,
    hideProgressBar: options.hideProgressBar || false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    ...options
  });
};

/**
 * Show a default toast notification
 * @param {string} message - The message to display
 * @param {object} options - Additional toast options (duration, position, etc.)
 */
export const showToast = (message, options = {}) => {
  toast(message, {
    position: options.position || 'top-right',
    autoClose: options.autoClose || 4000,
    hideProgressBar: options.hideProgressBar || false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    ...options
  });
};

/**
 * Dismiss all active toasts
 */
export const dismissAll = () => {
  toast.dismiss();
};

/**
 * Dismiss a specific toast by ID
 * @param {number|string} toastId - The ID of the toast to dismiss
 */
export const dismissToast = (toastId) => {
  toast.dismiss(toastId);
};

// Export default object with all methods for convenience
export default {
  success: showSuccess,
  error: showError,
  warning: showWarning,
  info: showInfo,
  toast: showToast,
  dismissAll,
  dismiss: dismissToast
};

